import * as React from 'react';
import { Button, ButtonType } from 'office-ui-fabric-react/lib/Button';
import controlStrings from 'owa-strings/owa-common-strings';

const spriteStyles = require('owa-sprite/dist/styles/ribbon_sprite.css');
const styles = require('./MessageFormatFull.scss');
const classNames = require('classnames/bind').bind(styles);

export interface FormatButtonProps {
    type: 'bold' | 'italic' | 'underline' | 'textcolor';
    isSelected: boolean;
    onClick?: (isSelected: boolean) => void;
}

export default class FormatButton extends React.Component<FormatButtonProps, {}> {
    render() {
        return (
            <Button
                buttonType={ButtonType.icon}
                type={this.props.type}
                className={classNames(styles.formatButton, {
                    isSelected: this.props.isSelected,
                })}
                data-is-focusable={true}
                title={controlStrings[this.props.type]}
                onClick={this.onClick}>
                <span className={spriteStyles[`ribbon-icon-${this.props.type}`]} />
            </Button>
        );
    }

    private onClick = () => {
        if (this.props.onClick) {
            this.props.onClick(!this.props.isSelected);
        }
    };
}
